export const contactConstant = {
  CONTACT_REQUEST: "CONTACT_REQUEST",
  CONTACT_SUCCESS: "CONTACT_SUCCESS",
  CONTACT_FAILURE: "CONTACT_FAILURE",

  OFFICE_REQUEST: "OFFICE_REQUEST",
  OFFICE_SUCCESS: "OFFICE_SUCCESS",
  OFFICE_FAILURE: "OFFICE_FAILURE",
};
